import { render, staticRenderFns } from "./AccountFunplus.vue?vue&type=template&id=65e3f8ce&scoped=true&"
import script from "./AccountFunplus.vue?vue&type=script&lang=js&"
export * from "./AccountFunplus.vue?vue&type=script&lang=js&"
import style0 from "./AccountFunplus.vue?vue&type=style&index=0&id=65e3f8ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e3f8ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/admin/workspace/ss/ss-web-game/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65e3f8ce')) {
      api.createRecord('65e3f8ce', component.options)
    } else {
      api.reload('65e3f8ce', component.options)
    }
    module.hot.accept("./AccountFunplus.vue?vue&type=template&id=65e3f8ce&scoped=true&", function () {
      api.rerender('65e3f8ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/social/AccountFunplus.vue"
export default component.exports